/*
 * Settings Messages
 *
 * This contains all the text for the Settings container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Settings';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'An exceptional service, at the right price',
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage: 'Switch to our professional plan as you grow.',
  },
  monthly: {
    id: `${scope}.monthly`,
    defaultMessage: 'Monthly',
  },
  yearly: {
    id: `${scope}.yearly`,
    defaultMessage: 'Yearly',
  },
  disount: {
    id: `${scope}.disount`,
    defaultMessage: 'discount',
  },
  basic: {
    id: `${scope}.basic`,
    defaultMessage: 'Basic',
  },
  silver: {
    id: `${scope}.silver`,
    defaultMessage: 'Silver',
  },
  gold: {
    id: `${scope}.gold`,
    defaultMessage: 'Gold',
  },
  platinum: {
    id: `${scope}.platinum`,
    defaultMessage: 'Platinum',
  },
  max: {
    id: `${scope}.max`,
    defaultMessage: 'Max',
  },
  members: {
    id: `${scope}.members`,
    defaultMessage: 'members',
  },
  groups: {
    id: `${scope}.groups`,
    defaultMessage: 'groups',
  },
  unlimited: {
    id: `${scope}.unlimited`,
    defaultMessage: 'Unlimited',
  },
  questionnaiers: {
    id: `${scope}.questionnaiers`,
    defaultMessage: 'Questionnaires',
  },
  getStarted: {
    id: `${scope}.getStarted`,
    defaultMessage: 'Get Started',
  },
  currPlan: {
    id: `${scope}.currPlan`,
    defaultMessage: 'Current Plan',
  },
  changePlan: {
    id: `${scope}.changePlan`,
    defaultMessage: 'Change to this',
  },
  billInfo: {
    id: `${scope}.billInfo`,
    defaultMessage: 'Billing Information',
  },
  billHistory: {
    id: `${scope}.billHistory`,
    defaultMessage: 'Billing History',
  },
  spaceOwner: {
    id: `${scope}.spaceOwner`,
    defaultMessage: 'Space Owner',
  },
  spaceAdministrator: {
    id: `${scope}.spaceAdministrator`,
    defaultMessage: 'Space Administrator',
  },
  uName: {
    id: `${scope}.uName`,
    defaultMessage: 'User Name',
  },
  fName: {
    id: `${scope}.fName`,
    defaultMessage: 'First Name',
  },
  lName: {
    id: `${scope}.lName`,
    defaultMessage: 'Last Name',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  paidUntil: {
    id: `${scope}.paidUntil`,
    defaultMessage: 'Paid Until',
  },
  country: {
    id: `${scope}.country`,
    defaultMessage: 'Country',
  },
  phonenum: {
    id: `${scope}.phonenum`,
    defaultMessage: 'Phone Number',
  },
  optional: {
    id: `${scope}.optional`,
    defaultMessage: 'optional',
  },
  cancelSubscr: {
    id: `${scope}.cancelSubscr`,
    defaultMessage: 'Cancel Subscription',
  },
  saveChanges: {
    id: `${scope}.saveChanges`,
    defaultMessage: 'Save Changes',
  },
  additionalSpaceAdmins: {
    id: `${scope}.additionalSpaceAdmins`,
    defaultMessage: 'Additional Space Administrators',
  },
  sex: {
    id: `${scope}.sex`,
    defaultMessage: 'Sex',
  },
  birth: {
    id: `${scope}.birth`,
    defaultMessage: 'Birth',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Phone',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  inviteAdmin: {
    id: `${scope}.inviteAdmin`,
    defaultMessage: 'Invite New Administrator',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  pending: {
    id: `${scope}.pending`,
    defaultMessage: 'Pending',
  },
  warn: {
    id: `${scope}.warn`,
    defaultMessage: 'WARNING: Deleting a MUSCLELAB Cloud Space is IMMEDIATE and CANNOT BE UNDONE. All of Your project data will be deleted IMMEDIATELY.',
  },
  deleteSpace: {
    id: `${scope}.deleteSpace`,
    defaultMessage: 'Delete Space',
  },
  male: {
    id: `${scope}.male`,
    defaultMessage: 'Male',
  },
  female: {
    id: `${scope}.female`,
    defaultMessage: 'Female',
  },
  confirmationDeleteSpace: {
    id: `${scope}.confirmationDeleteSpace`,
    defaultMessage: 'Are you sure you want to delete this space? If you have an active subscription it will be canceled.',
  },
  confirmationCancelSub: {
    id: `${scope}.confirmationCancelSub`,
    defaultMessage: 'Are you sure you want to cancel subscription?',
  },
  role: {
    id: `${scope}.role`,
    defaultMessage: 'Role',
  },
  enrolled: {
    id: `${scope}.enrolled`,
    defaultMessage: 'Enrolled',
  },
  invited: {
    id: `${scope}.invited`,
    defaultMessage: 'Invited',
  },
});

